import closeIcon from "@assets/images/x-circle.png";
import { Paper } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles(
  theme => ({
    root: {
      display: "flex",
      padding: "1.6rem 2rem",
      alignItems: "center",
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: "6px",
      overflow: "hidden",
      "& .MuiTypography-root": {
        marginLeft: "1rem"
      }
    }
  }),
  { name: "NotFoundContract" }
);

const NotFoundContract = () => {
  const classes = useStyles();
  return (
    <Paper className={classes.root}>
      <img src={closeIcon} alt="close" />
      <MyTypography variant="body2">
        <FormattedMessage
          defaultMessage="ไม่พบรายการที่ค้นหา"
          description="data not found message"
        />
      </MyTypography>
    </Paper>
  );
};

export default NotFoundContract;
